<template>
  <div class="wblog">
    <h2>WBLOG</h2>
    <div class="wblog_cards">
      <div class="column">
        <div class="post-module">
          <!-- Thumbnail-->
          <div class="thumbnail">
            <img src="@/assets/images/wblog/wblog-1.png" />
          </div>
          <!-- Post Content-->
          <div class="post-content">
            <h1 class="title">Expert opinion</h1>

            <p class="description">
              Accuracy and timeliness: Two critical measures that define the
              quality of data in logistics...
            </p>
            <div class="post-meta">
              <span class="timestamp"> 09 Jun 2021</span>
            </div>
          </div>
        </div>
        <div class="demo-title">News</div>
      </div>
      <div class="column">
        <div class="post-module">
          <!-- Thumbnail-->
          <div class="thumbnail">
            <img src="@/assets/images/wblog/wblog-2.png" />
          </div>
          <!-- Post Content-->
          <div class="post-content">
            <h1 class="title">Expert opinion</h1>

            <p class="description">
              Accuracy and timeliness: Two critical measures that define the
              quality of data in logistics...
            </p>
            <div class="post-meta">
              <span class="timestamp"> 09 Jun 2021</span>
            </div>
          </div>
        </div>
        <div class="demo-title">Event</div>
      </div>
      <div class="column">
        <!-- Post-->
        <div class="post-module">
          <!-- Thumbnail-->
          <div class="thumbnail">
            <img src="@/assets/images/wblog/wblog-3.png" />
          </div>
          <!-- Post Content-->
          <div class="post-content">
            <h1 class="title">Expert opinion</h1>

            <p class="description">
              Accuracy and timeliness: Two critical measures that define the
              quality of data in logistics...
            </p>
            <div class="post-meta">
              <span class="timestamp"> 09 Jun 2021</span>
            </div>
          </div>
        </div>
        <div class="demo-title">Recuitment</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.wblog {
  padding: 100px 30px;
  @media (min-width: 900px) {
    padding: 100px 150px;
  }
  @media (min-width: 1900px) {
    padding: 100px 400px !important;
  }

  h2 {
    position: relative;
    font-weight: 800;
    font-size: 3.2rem;
    line-height: 5.3rem;
    /* identical to box height */
    text-align: center;
    letter-spacing: -0.02em;
    color: #2b938c;
  }
  h2::before {
    content: "";
    position: absolute;
    width: 10%;
    height: 6px; // suit your need
    border-radius: 50px;
    background: #2b938c; // suit your need
    top: 90%;
    left: 50%;
    transform: translate(-50%);
  }

  &_cards {
    display: grid;
    gap: 50px;
    justify-content: center;
    margin-top: 50px;
    grid-template-columns: 1fr;

    @media (min-width: 900px) {
      grid-template-columns: repeat(3, 1fr);
    }
    @media (min-width: 1500px) {
      gap: 100px;
      grid-template-columns: repeat(3, 1fr);
    }

    .column {
      .post-module:hover {
        .thumbnail img {
          -webkit-transform: scale(1.1);
          -moz-transform: scale(1.1);
          transform: scale(1.1);
          opacity: 0.6;
        }
        .post-content {
          .description {
            visibility: visible !important;
            opacity: 1 !important;
          }
        }
      }
      .post-module {
        position: relative;
        z-index: 1;
        display: block;
        background: #f8f7f7;
        min-width: 270px;
        height: 483px;

        -webkit-box-shadow: 0px 1px 2px 0px rgb(0 0 0 / 15%);
        -moz-box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
        box-shadow: 0px 1px 2px 0px rgb(0 0 0 / 15%);
        -webkit-transition: all 0.3s linear 0s;
        -moz-transition: all 0.3s linear 0s;
        -ms-transition: all 0.3s linear 0s;
        -o-transition: all 0.3s linear 0s;
        transition: all 0.3s linear 0s;
        .thumbnail {
          background: #000000;
          height: 333px;
          overflow: hidden;
          img {
            display: block;
            width: 100%;
            height: 100%;
            -webkit-transition: all 0.3s linear 0s;
            -moz-transition: all 0.3s linear 0s;
            -ms-transition: all 0.3s linear 0s;
            -o-transition: all 0.3s linear 0s;
            transition: all 0.3s linear 0s;
          }
        }
        .post-content {
          position: absolute;
          bottom: 0;
          background: #f8f7f7;
          width: 100%;
          padding: 20px;
          -webkti-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
          -webkit-transition: all 0.3s cubic-bezier(0.37, 0.75, 0.61, 1.05) 0s;
          -moz-transition: all 0.3s cubic-bezier(0.37, 0.75, 0.61, 1.05) 0s;
          -ms-transition: all 0.3s cubic-bezier(0.37, 0.75, 0.61, 1.05) 0s;
          -o-transition: all 0.3s cubic-bezier(0.37, 0.75, 0.61, 1.05) 0s;
          transition: all 0.3s cubic-bezier(0.37, 0.75, 0.61, 1.05) 0s;

          .title {
            margin: 0;
            padding: 0 0 20px;
            color: #333333;
            font-size: 1.2rem;
            font-weight: 700;
          }

          .description {
            font-size: 1.1rem;
            line-height: 1.35rem;
            font-weight: 400;
            height: 98px;
            //  opacity: 1
            color: #000;
            // visibility: hidden;
            // opacity: 0;
            height: 0;
            height: auto !important;

            transition: visibility 0s, height 1.5s linear, opacity 0.5s linear;
          }
          .post-meta {
            margin: 10px 0 0;
            color: #000;
          }
        }
      }
      .demo-title {
        font-size: 1.5rem;
        line-height: 2rem;
        /* identical to box height */

        text-align: center;
        letter-spacing: -0.02em;
        margin-top: 5px;
        color: #2b938c;
      }
    }
  }
}
</style>